import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Receipt, Users, FlaskConical, TrendingUp, DollarSign, AlertCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function LISDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('vendor_token');

  const fetchStats = useCallback(async () => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const [billRes, testRes, patientRes] = await Promise.all([
        fetch(`${API}/api/lis/bills/stats`, { headers }),
        fetch(`${API}/api/lis/tests?limit=1`, { headers }),
        fetch(`${API}/api/lis/patients?limit=1`, { headers })
      ]);
      const billStats = await billRes.json();
      const testData = await testRes.json();
      const patientData = await patientRes.json();
      setStats({
        ...billStats,
        total_tests: testData.total || 0,
        total_patients: patientData.total || 0
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchStats(); }, [fetchStats]);

  if (loading) return <div className="flex items-center justify-center h-64 text-slate-500">Loading...</div>;

  const cards = [
    { label: 'Total Bills', value: stats?.total_bills || 0, icon: Receipt, color: 'text-blue-600 bg-blue-50' },
    { label: 'Revenue', value: `Rs.${(stats?.total_revenue || 0).toLocaleString()}`, icon: TrendingUp, color: 'text-emerald-600 bg-emerald-50' },
    { label: 'Received', value: `Rs.${(stats?.total_received || 0).toLocaleString()}`, icon: DollarSign, color: 'text-green-600 bg-green-50' },
    { label: 'Due', value: `Rs.${(stats?.total_due || 0).toLocaleString()}`, icon: AlertCircle, color: 'text-red-600 bg-red-50' },
    { label: 'Tests in Rate List', value: stats?.total_tests || 0, icon: FlaskConical, color: 'text-purple-600 bg-purple-50' },
    { label: 'Patients', value: stats?.total_patients || 0, icon: Users, color: 'text-amber-600 bg-amber-50' },
  ];

  return (
    <div data-testid="lis-dashboard">
      <h1 className="text-2xl font-bold text-slate-800 mb-6">Lab Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {cards.map((c, i) => {
          const Icon = c.icon;
          return (
            <Card key={`card-${i}`} className="border-slate-200">
              <CardContent className="p-4">
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center mb-3 ${c.color}`}>
                  <Icon className="w-4.5 h-4.5" />
                </div>
                <p className="text-xs text-slate-500 mb-1">{c.label}</p>
                <p className="text-lg font-bold text-slate-800" data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, '-')}`}>{c.value}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
